import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
const LeaveRequest = () => {
  const navigate = useNavigate();
  const TableData = [
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Panding",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Panding",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },

    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Accepted",
    },
    {
      startDate: "Jan 04, 2022",
      endDate: "Jan 04, 2022",
      title: "Lorem ipsum dolor sit a...",
      description: "Fusce tincidunt ante ex, quis aliquam nisl suscipit at.",
      status: "Rejected",
    },
  ];
  const ActionHandler = (e, status) => {
    const actionSelected = e.target.value;
    if (actionSelected === "Edit") {
      navigate("/tutor-panel/leave-request/create", {
        state: { type: "edit" },
      });
    } else if (actionSelected === "View") {
      navigate("/tutor-panel/leave-request/view", {
        state: { status: status },
      });
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={9} md={9} sm={8} xs={4}></Grid>
            <Grid item xl={2} lg={3} md={3} sm={4} xs={8}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => {
                  navigate("/tutor-panel/leave-request/create", {
                    state: { type: "Create" },
                  });
                }}
              >
                <p className="page-header-button-text">Create Leve Request</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Search by Leave Title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">leave request</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="student-panel-leave-table-id-heading">ID</th>
                <th className="student-panel-leave-table-start-date-heading">
                  Start Date
                </th>
                <th className="student-panel-leave-table-end-date-heading">
                  End Date
                </th>
                <th className="student-panel-leave-table-leave-title-heading">
                  Leave Title
                </th>
                <th className="student-panel-leave-table-leave-description-heading">
                  Leave Discription
                </th>
                <th className="student-panel-leave-table-status-heading"></th>
                <th className="student-panel-leave-table-action-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">{tableValue.startDate}</td>
                    <td className="table-data">{tableValue.endDate}</td>
                    <td className="table-data">{tableValue.title}</td>
                    <td className="table-data">{tableValue.description}</td>
                    <td className="table-data">
                      <div
                        className="student-panel-leave-table-status"
                        style={{
                          backgroundColor:
                            tableValue.status === "Panding"
                              ? "#FFD1B0"
                              : tableValue.status === "Accepted"
                              ? "#D2FFEB"
                              : "#FFB0B0",
                          color:
                            tableValue.status === "Panding"
                              ? "#B84D00"
                              : tableValue.status === "Accepted"
                              ? "#098B51"
                              : "#B80000",
                        }}
                      >
                        {tableValue.status}
                      </div>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onClick={(e) => ActionHandler(e, tableValue.status)}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default LeaveRequest;
